/**
 * wa.me click-to-chat hand-off — the WhatsApp channel's `client_handoff`.
 *
 * Sends from the CLICKER's own WhatsApp, never the tenant's business number
 * (that is the in-app composer, gated on a two-way connection). Non-digits are
 * stripped from the phone (wa.me wants bare E.164 digits); an optional `text`
 * is URL-encoded as the message prefill.
 */
export function buildContactWhatsAppUrl(phone: string, text?: string): string {
  const digits = phone.replace(/\D/g, '');
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}
